import { Factory } from 'rosie';

Factory.define('Rules').attr('name', 'RULES');

Factory.define('RulesWithDefaults').extend('Rules');
